$(document).ready(function () {

    $(".ad-header-btn a.scroll-btn").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        var target = $("#ad-form-block");
        if(target.length){
            $("html, body").animate({
                scrollTop: target.offset().top
            }, 600);
        }
    });

    $(".ad-traffic-banner-overlay a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        var target = $("#ad-form-block");
        if(target.length){
            $("html, body").animate({
                scrollTop: target.offset().top
            }, 600);
        }
    });

    $(".ad-traffic-best-data a.scroll-btn").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        var target = $("#ad-form-block");
        if(target.length){
            $("html, body").animate({
                scrollTop: target.offset().top
            }, 600);
        }
    });

    $(".ad-footer-btn a.scroll-btn").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        var target = $("#ad-form-block");
        if(target.length){
            $("html, body").animate({
                scrollTop: target.offset().top
            }, 600);
        }
    });

    function initSlick() {
        if ($(window).width() <= 989) {
            if (!$('.ad-traffic-best-list').hasClass('slick-initialized')) {
                $('.ad-traffic-best-list').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                responsive: [
                    {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true
                    }
                    }
                ]
                });
            }
        } else {
            if ($('.ad-traffic-best-list').hasClass('slick-initialized')) {
                $('.ad-traffic-best-list').slick('unslick');
            }
        }
    }

  initSlick();

  $(window).on('resize', function () {
    initSlick();
  });

    /* -----------------------------
       CART QUANTITY LIMITER
    ------------------------------*/
    $("div.drawer__cart-items-wrapper")
        .find(".quantity__input")
        .on("input", function () {
            var maxVal = $(this).attr("max");
            var currentVal = parseInt($(this).val());
            if (maxVal && currentVal > maxVal) {
                $(this).val(maxVal);
            }
        });

    /* -----------------------------
       FAQ: INITIAL ACTIVE TAB
    ------------------------------*/
    let firstTab = $(".faq-collection-sec .tab").first();
    let firstTabPane = $("#" + firstTab.data("tab"));

    firstTab.addClass("active");
    firstTabPane.addClass("active");
    firstTabPane.find(".faq-item").first().addClass("active_item");

    $(".faq-collection-sec .tab").on("click", function () {
        let selectedTab = $(this);
        let selectedTabPane = $("#" + selectedTab.data("tab"));
        $(".faq-collection-sec .tab").removeClass("active");
        $(".faq-collection-sec .tab-pane").removeClass("active");
        selectedTab.addClass("active");
        selectedTabPane.addClass("active");
        selectedTabPane.find(".faq-item").removeClass("active_item");
        selectedTabPane.find(".faq-item").first().addClass("active_item");
    });

    /* -----------------------------
       FAQ ACCORDION
    ------------------------------*/
    $(".faq-collection-sec").on("click", ".faq-question", function () {
        let faqItem = $(this).closest(".faq-item");
        let faqAnswer = faqItem.find(".faq-answer");
        let currentTabPane = faqItem.closest(".tab-pane");

        if (faqItem.hasClass("active_item")) {
            faqItem.removeClass("active_item");
            faqAnswer.slideUp();
        } else {
            currentTabPane.find(".faq-item").removeClass("active_item").find(".faq-answer").slideUp();
            faqItem.addClass("active_item");
            faqAnswer.slideDown();
        }
    });

    /* -----------------------------
       PRODUCT SLIDER
    ------------------------------*/
    $(".related-prd-list-slider").slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        draggable: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } },
        ],
    });

    /* -----------------------------
       HELP CENTER TABS
    ------------------------------*/
    $(".help-center-faq-sec .tab").on("click", function () {
        $(".help-center-faq-sec .tab").removeClass("active");
        $(this).addClass("active");
        $(".help-center-faq-sec .tab-content").removeClass("active");
        let targetTab = $("#" + $(this).data("tab"));
        targetTab.addClass("active");
    });

    $(".help-center-faq-sec .tab a").on("click", function (ev) {
        var hheight = $("div.section-header").height();
        ev.preventDefault();
        var targetId = $(this).attr("href");
        $("html, body").animate({ scrollTop: $(targetId).offset().top - 2 * hheight }, 500);
    });

    $(".help-center-faq-sec .accordion-header").on("click", function () {
        var $currentItem = $(this).closest(".accordion-item");
        var $content = $currentItem.find(".accordion-content");
        var $tabContent = $(this).closest(".tab-content");

        if ($content.hasClass("open")) {
            $content.removeClass("open").stop(true, true).slideUp(300);
            $currentItem.find(".arrow-down").show();
            $currentItem.find(".arrow-up").hide();
        } else {
            $tabContent.find(".accordion-content").removeClass("open").stop(true, true).slideUp(300);
            $tabContent.find(".arrow-down").show();
            $tabContent.find(".arrow-up").hide();

            $content.addClass("open").stop(true, true).slideDown(300);
            $currentItem.find(".arrow-down").hide();
            $currentItem.find(".arrow-up").show();
        }
    });

    /* -----------------------------
       STICKY HEADER ON SCROLL
    ------------------------------*/
    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 60) {
            $("header").addClass("sticky-search-b");
        } else {
            $("header").removeClass("sticky-search-b");
        }
    });

    /* -----------------------------
       POPUP: QUOTE + LOGIN
    ------------------------------*/
    $("a.button--primary.open-quote-form").on("click", function (e) {
        e.preventDefault();
        $("#quote-popup").removeClass("hidden").css("display", "block");
        $("body").addClass("quote-open");
    });

    $(".quote-popup__close, .quote-popup__overlay").on("click", function () {
        $("#quote-popup").addClass("hidden").css("display", "none");
        $("body").removeClass("quote-open");
    });

    $("a.button--primary.open-login-popup").on("click", function (e) {
        e.preventDefault();
        $("#login-popup").removeClass("hidden").css("display", "block");
        $("body").addClass("quote-open");
    });

    $(".login-popup__close, .login-popup__overlay").on("click", function () {
        $("#login-popup").addClass("hidden").css("display", "none");
        $("body").removeClass("quote-open");
    });

    /* -----------------------------
       DYNAMIC PRODUCT LIST ENTRIES
    ------------------------------*/
    function updateEntryButtons() {
        const entries = $("#product-entries .product-entry");
        entries.each(function (index) {
            const deleteBtn = $(this).find(".delete-product-entry");
            const addBtn = $(this).find(".add_entry_btn");

            if (index === 0) {
                addBtn.removeClass("hidden");
                deleteBtn.addClass("hidden");
            } else {
                addBtn.addClass("hidden");
                deleteBtn.removeClass("hidden");
            }
        });
    }

    $("#product-entries").on("click", ".add_entry_btn", function () {
        let newEntry = $(".product-entry:first").clone();
        newEntry.find("input").val("");
        $("#product-entries").append(newEntry);
        updateEntryButtons();
    });

    $("#product-entries").on("click", ".delete-product-entry", function () {
        $(this).closest(".product-entry").remove();
        updateEntryButtons();
    });

    updateEntryButtons();

    /* -----------------------------
       PRODUCT LIST SERIALIZER
    ------------------------------*/
    var $productListField = $("#ContactForm-product-list");
    var $productEntriesWrapper = $("#product-entries");

    function updateProductList() {
        var data = [];
        $productEntriesWrapper.find(".product-entry").each(function () {
            var item = $(this).find('input[name="product-item"]').val().trim();
            var qty = $(this).find('input[name="product-quantity"]').val().trim();

            if (item || qty) {
                data.push("Item: " + (item || "N/A") + ", Qty: " + (qty || "N/A"));
            }
        });
        $productListField.val(data.join(" | "));
    }

    $productEntriesWrapper.on(
        "input change",
        'input[name="product-item"], input[name="product-quantity"]',
        updateProductList
    );

    $("body").on("click", ".add_entry_btn, .delete-product-entry", function () {
        setTimeout(updateProductList, 100);
    });

    updateProductList();

    /* -----------------------------------------------------
       FORM VALIDATION ➜ Combined Required Conditions
       (1) At least one .hear-option checkbox checked
       (2) #agree-terms checked
    ------------------------------------------------------*/
    const $submitBtn = $(".quote-c-form button");
    const $agreeTerms = $("#agree-terms");
    const $hearCheckboxes = $(".hear-option");

    function checkHearOptions() {
        let anyChecked = false;
        $hearCheckboxes.each(function () {
            if ($(this).is(":checked")) {
                anyChecked = true;
            }
        });
        return anyChecked;
    }

    function updateSubmitState() {
        const hearOK  = checkHearOptions();
        const termsOK = $agreeTerms.is(":checked");
        $submitBtn.prop("disabled", !(hearOK && termsOK));
    }

    $hearCheckboxes.on("change", updateSubmitState);
    $agreeTerms.on("change", updateSubmitState);
    updateSubmitState(); // run on load

    /* -----------------------------
       PRODUCT PAGE TABS
    ------------------------------*/
    $("ul.tabs").each(function () {
        var active, content,
            links = $(this).find("a");

        active = links.first().addClass("active");
        content = $(active.attr("href"));

        links.not(":first").each(function () {
            $($(this).attr("href")).hide();
        });

        $(this).find("a")
            .click(function (e) {
                e.preventDefault();

                active.removeClass("active");
                active.parents(".cgt-desc").find(".main-content").addClass("cgt-content");

                content.hide();
                active = $(this);
                content = $($(this).attr("href"));

                active.addClass("active");
                content.show();
                return false;
            });

        $(this).find(".specifications").click(function (e) {
            $(this).parents(".cgt-desc").find(".main-content").removeClass("cgt-content");
        });
    });

    $(".sitewide-product .specifications_tab").hide();
    $(".sitewide-product a.specifications").click(function () {
        $(".sitewide-product .specifications_tab").show();
    });
    $("a.description").click(function () {
        $(".sitewide-product .specifications_tab").hide();
    });

    /* -----------------------------
       A–Z NAVIGATION SCROLL
    ------------------------------*/
    $("#az-navigation ul li.active_letter a").on("click", function (e) {
        e.preventDefault();
        var targetId = $(this).attr("href");
        var target = $(targetId);

        if (target.length) {
            $("html, body").animate({ scrollTop: target.offset().top }, 600);
        }
    });

});
